export var PasswordChangePageContainerActionTypes;
(function (PasswordChangePageContainerActionTypes) {
    PasswordChangePageContainerActionTypes["INITIALIZE"] = "passwordChange.page.INITIALIZE";
    PasswordChangePageContainerActionTypes["SET_STATE"] = "passwordChange.page.SET_STATE";
    PasswordChangePageContainerActionTypes["HANDLE_CHANGE_PASSWORD"] = "passwordChange.page.HANDLE_CHANGE_PASSWORD";
    PasswordChangePageContainerActionTypes["PROCESS_RESPONSE"] = "passwordChange.page.PROCESS_RESPONSE";
})(PasswordChangePageContainerActionTypes || (PasswordChangePageContainerActionTypes = {}));
